import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

const pin = (color, label, big) =>
  L.divIcon({
    className: "cph-pin",
    html: `<div style="
      background:${color};
      width:${big ? 20 : 15}px;height:${big ? 20 : 15}px;
      border:3px solid #fff;border-radius:50%;
      box-shadow:0 3px 8px rgba(0,0,0,0.28);
      position:relative;">
      ${label ? `<span style="position:absolute;left:50%;top:-28px;transform:translateX(-50%);white-space:nowrap;font-family:'Plus Jakarta Sans',sans-serif;font-weight:800;font-size:11px;color:#18181B;background:#fff;border-radius:9999px;box-shadow:0 2px 8px rgba(0,0,0,0.15);padding:2px 9px;">${label}</span>` : ""}
    </div>`,
    iconSize: [big ? 20 : 15, big ? 20 : 15],
    iconAnchor: [big ? 10 : 7, big ? 10 : 7],
  });

// Auto-detect: Apple Maps on iPhone/iPad, Google Maps everywhere else. Opens the spot (no directions).
const isIOS =
  typeof navigator !== "undefined" &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent || "") ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

const mapsHref = (coords, name) => {
  const [lat, lng] = coords;
  return isIOS
    ? `https://maps.apple.com/?ll=${lat},${lng}&q=${encodeURIComponent(name || "")}`
    : `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
};

const TILE = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
const ATTRIB =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

function FitBounds({ markers, center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (markers.length > 1) {
      const bounds = L.latLngBounds(markers.map((m) => m.coords));
      map.fitBounds(bounds, { padding: [45, 45], maxZoom: 15 });
    } else if (markers.length === 1) {
      map.setView(markers[0].coords, 15);
    } else {
      map.setView(center, zoom);
    }
    // run once per mount (parent remounts via key when the area changes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}

export const CityMap = ({
  center = [55.6805, 12.575],
  zoom = 12,
  markers = [],
  height = "100%",
  scrollWheelZoom = false,
  fitToMarkers = false,
}) => (
  <MapContainer
    center={center}
    zoom={zoom}
    scrollWheelZoom={scrollWheelZoom}
    style={{ height, width: "100%" }}
    zoomControl={true}
  >
    <TileLayer url={TILE} attribution={ATTRIB} maxZoom={19} className="cph-map-tiles" />
    {fitToMarkers && <FitBounds markers={markers} center={center} zoom={zoom} />}
    {markers.map((m, i) => (
      <Marker key={i} position={m.coords} icon={pin(m.color || "#DF3226", m.label || "", m.big)}>
        <Popup>
          <div style={{ fontFamily: "'Nunito Sans', sans-serif", minWidth: 150 }}>
            <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 15 }}>{m.name}</div>
            {m.tag && <div style={{ fontSize: 12, color: "#555" }}>{m.tag}</div>}
            <a
              href={mapsHref(m.coords, m.name)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="map-open-in-maps"
              style={{ display: "inline-flex", alignItems: "center", gap: 4, marginTop: 8, fontWeight: 800, color: "#1E3A8A" }}
            >
              Open in Maps ↗
            </a>
            {m.to && (
              <Link to={m.to} style={{ display: "block", marginTop: 6, fontWeight: 800, color: "#DF3226" }}>
                Explore →
              </Link>
            )}
          </div>
        </Popup>
      </Marker>
    ))}
  </MapContainer>
);
